import React from "react";

const RadioGroup = ({
  error,
  errorText,
  displayDirection = "row",
  flexWrap = false,
  gapSize = "24px",
  colGapSize = "24px", //used when flexWrap is TRUE
  radioWidth,
  name,
  value,
  options,
  onChange,
  tabindex=undefined,
}: any) => {
  return (
    <>
      <div
        style={{
          flexDirection:displayDirection  && ['row', 'column', 'row-reverse', 'column-reverse'].includes(displayDirection) ? displayDirection : undefined,
          gap: `${gapSize}`,
          columnGap: flexWrap ? colGapSize : "",
        }}
        className={`flex ${flexWrap ? "flex-wrap" : ""}`}
      >
        {options.map((option: any, idx: any) => (
          <div
            key={idx}
            className="flex flex-col"
            style={{ width: radioWidth && `calc(${radioWidth} - ${gapSize})` }}
          >
            <div
              key={idx}
              className={`w-fit p-1 rounded relative ${
                !option?.disabled
                  ? "hover:cursor-pointer hover:bg-[#FFF3E5]"
                  : "hover:cursor-default"
              }`}
              onClick={() => {
                if (!option?.disabled) onChange(option.value);
                return;
              }}
            >
              <input
                className="appearance-none mr-8"
                type="radio"
                id={option.label}
                name={name}
                value={option.value}
                tabindex={tabindex}
              />
              <label
                className={`text-sm leading-[1.3125rem] text-normal ${
                  !option?.disabled
                    ? "alu-text-base-2 hover:cursor-pointer"
                    : "text-[#BBB]"
                }`}
              >
                {option.label}
              </label>
              <button
                disabled={option?.disabled}
                type="button"
                className="absolute left-[0.25rem] top-[0.25rem] bottom-[0.25rem] flex items-center justify-center"
              >
                {option.value === value ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_8574_18890)">
                      <path
                        d="M12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
                        fill={!option?.disabled ? "#FF861A" : "#BBB"}
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_8574_18890">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_8574_18891)">
                      <path
                        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
                        fill={!option?.disabled ? "#808080" : "#BBB"}
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_8574_18891">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </button>
            </div>
            {option?.note && (
              <span className="alu-text-error text-sm">{option?.note}</span>
            )}
          </div>
        ))}
      </div>
      {error && (
        <p className="alu-text-error text-sm mt-2">
          {errorText ? `*${errorText}` : "＊エラーテキストが入ります"}
        </p>
      )}
    </>
  );
};

export default RadioGroup;
